// extracted by mini-css-extract-plugin
export default {"wrapperMain":"Deposit_wrapperMain__JWxGp","ani":"Deposit_ani__LckSh"};